import {createWebHistory,createRouter} from 'vue-router'
import AppLayout from '@/views/Layouts/AppLayout'

/** Dashboard */
import DashboardPage from '@/views/Dashboard/DashboardPage'
/** Tenants */
import TenantsPage from '@/views/Tenants/TenantsPage'
/** Landlords */
import LandlordsPage from '@/views/Landlords/LandlordsPage'
/** Users */
import SingleUserPage from '@/views/Users/SingleUserPage'
/** Invites */
import InvitesPage from '@/views/Invites/InvitesPage'
/** Admins */
import AdminsPage from '@/views/Admins/AdminsPage'
import EditUserPage from '@/views/Admins/EditAdminPage'
/** Properties */
import HousesPage from '@/views/Properties/HousesPage'
import EditHousePage from '@/views/Properties/EditHousePage'
/** Contracts */
import ContractsPage from '@/views/Contracts/ContractsPage'
import ContractSinglePage from '@/views/Contracts/ContractSinglePage'
import CallbackPage from '@/views/Contracts/CallbackPage'
/** Proposals */
import CreateContractProposalPage from '@/views/Contracts/Proposals/CreateContractProposalPage'
import ContractProposalsPage from '@/views/Contracts/Proposals/ContractProposalsPage'
import ContractProposalSinglePage from '@/views/Contracts/Proposals/ContractProposalSinglePage'
import EditContractProposalPage from '@/views/Contracts/Proposals/EditContractProposalPage'
/** Templates */
import ContractTemplatesPage from '@/views/Contracts/Templates/ContractTemplatesPage'
/** Issues */
import IssuesPage from '@/views/Contracts/Issues/IssuesPage'
import IssuesSinglePage from '@/views/Contracts/Issues/IssuesSinglePage'
/** Profile */
import ProfilePage from '@/views/Profile/ProfilePage'
/** Login */
import LoginView from '@/views/Auth/LoginView'
/** Logout */
import LogoutView from '@/views/Auth/LogoutView'
/** Sign Up */
import SignupView from '@/views/Auth/SignupView'
/** Forgot Password */
import ForgotPasswordView from '@/views/Auth/ForgotPasswordView'
/** Legals */
import PrivacyPolicyView from '@/views/Public/PrivacyPolicyView'
/** Deep Links */
import VerifyEmailView from '@/views/Public/VerifyEmailView'
import ResetPasswordView from '@/views/Public/ResetPasswordView'
 
export const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'AppLayout',
      component: AppLayout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/dashboard',
          name: 'DashboardPage',
          component: DashboardPage,
          meta: {
            title: 'Pacto | Web Dashboard - Dashboard 💼'
          }
        },
        {
          path: '/tenants',
          name: 'TenantsPage',
          component: TenantsPage,
          meta: {
            title: 'Pacto | Web Dashboard - Tenants 💼'
          }
        },
        {
          path: '/landlords',
          name: 'LandlordsPage',
          component: LandlordsPage,
          meta: {
            title: 'Pacto | Web Dashboard - Landlords 💼'
          }
        },
        {
          path: '/users/:uuid',
          name: 'SingleUserPage',
          component: SingleUserPage,
          meta: {
            title: 'Pacto | Web Dashboard - User 💼'
          }
        },
        {
          path: '/invites',
          name: 'InvitesPage',
          component: InvitesPage,
          meta: {
            title: 'Pacto | Web Dashboard - Invites 💼'
          }
        },
        {
          path: '/users',
          name: 'AdminsPage',
          component: AdminsPage,
          meta: {
            title: 'Pacto | Web Dashboard - Admins 💼'
          }
        },
        {
          path: '/users/:uid',
          name: 'EditUserPage',
          component: EditUserPage,
          meta: {
            title: 'Pacto | Web Dashboard - Edit House 💼'
          }
        },
        {
          path: '/contracts',
          name: 'ContractsPage',
          component: ContractsPage,
          meta: {
            title: 'Pacto | Web Dashboard - Contracts 💼'
          }
        },
        {
          path: '/contracts/details/:uuid',
          name: 'ContractSinglePage',
          component: ContractSinglePage,
          meta: {
            title: 'Pacto | Web Dashboard - Contract Details 💼'
          }
        },
        {
          path: '/contracts/templates',
          name: 'ContractTemplatesPage',
          component: ContractTemplatesPage,
          meta: {
            title: 'Pacto | Web Dashboard - Contract Templates 💼'
          }
        },
        {
          path: '/contracts/proposals',
          name: 'ContractProposalsPage',
          component: ContractProposalsPage,
          meta: {
            title: 'Pacto | Web Dashboard - Contract Proposals 💼'
          }
        },
        {
          path: '/contracts/proposals/create',
          name: 'CreateContractProposalPage',
          component: CreateContractProposalPage,
          meta: {
            title: 'Pacto | Web Dashboard - New Contract Proposal 💼'
          }
        },
        {
          path: '/contracts/proposals/:uuid',
          name: 'ContractProposalSinglePage',
          component: ContractProposalSinglePage,
          meta: {
            title: 'Pacto | Web Dashboard - Contract Proposal 💼'
          }
        },
        {
          path: '/contracts/proposals/:uuid/edit',
          name: 'EditContractProposalPage',
          component: EditContractProposalPage,
          meta: {
            title: 'Pacto | Web Dashboard - Edit Contract Proposal 💼'
          }
        },
        {
          path: '/contracts/callback',
          name: 'ContractsPageCallback',
          component: CallbackPage,
          meta: {
            title: 'Pacto | Web Dashboard - Contracts Callback 💼'
          }
        },
        {
          path: '/contracts/issues',
          name: 'IssuesPage',
          component: IssuesPage,
          meta: {
            title: 'Pacto | Web Dashboard - Issues 💼'
          }
        },
        {
          path: '/contracts/issues/:uuid',
          name: 'IssuesSinglePage',
          component: IssuesSinglePage,
          meta: {
            title: 'Pacto | Web Dashboard - Issue Details 💼'
          }
        },
        {
          path: '/houses',
          name: 'HousesPage',
          component: HousesPage,
          meta: {
            title: 'Pacto | Web Dashboard - Houses 💼'
          }
        },
        {
          path: '/houses/:uid',
          name: 'EditHousePage',
          component: EditHousePage,
          meta: {
            title: 'Pacto | Web Dashboard - Edit House 💼'
          }
        },
        {
          path: '/profile',
          name: 'ProfilePage',
          component: ProfilePage,
          meta: {
            title: 'Pacto | Web Dashboard - Profile 💼'
          }
        }
      ]
    },

    {
      path: '/login',
      name: 'LoginPage',
      component: LoginView,
      meta: {
        title: 'Pacto | Web Dashboard - Login 💼'
      }
    },

    {
      path: '/sign-up',
      name: 'SignupPage',
      component: SignupView,
      meta: {
        title: 'Pacto | Web Dashboard - Signup 💼'
      }
    },

    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPasswordView,
      meta: {
        title: 'Pacto | Web Dashboard - Forgot Password 💼'
      }
    },

    {
      path: '/logout',
      name: 'LogoutPage',
      component: LogoutView,
      meta: {
        title: 'Pacto | Web Dashboard - Logout 💼'
      }
    },

    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicyView,
      meta: {
        title: 'Pacto | Web Dashboard - Privacy Policy 💼'
      }
    },

    /** Deep Links */
    {
      path: '/verifyEmail',
      name: 'VerifyEmail',
      component: VerifyEmailView,
      meta: {
        title: 'Pacto | Web Dashboard - Verify Email 💼'
      }
    },

    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: ResetPasswordView,
      meta: {
        title: 'Pacto | Web Dashboard - Reset Password 💼'
      }
    },

    /** Redirect to Home */
    {
      path: '/:catchAll(.*)',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  //Meta and Page Title
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // Require Login
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      location.href = '/login'
    } else {
      next()
    }
  } else {
    next();
  }
})

export default router
